<template>
  <footer class="app-footer" :style="cssVars">
    <ul v-show="isContentLoaded" class="app-footer__nav">
      <li v-for="(text, index) in companyCopyright" :key="index">
        <span>{{ text }}</span>
      </li>
    </ul>
    <!-- <navigation-bar
      v-if="!isFlyerView"
      :card="menuKeyCard"
      :chirashi="menuChirashi"
      :point-benefits="menuPointBenefits"
      @click="$emit('click', $event)"
    /> -->
  </footer>
</template>

<script setup>
// import NavigationBar from '@/components/NavigationBar'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const runtimeConfig = useRuntimeConfig()
const data = await import(`@/data/${runtimeConfig.public.chainKey}/common/data.js`)

const props = defineProps({
  linkName: {
    type: String,
    default: '',
  },
  linkUrl: {
    type: String,
    default: '',
  },
  menuKeyCard: {
    type: Boolean,
    default: null,
  },
  menuChirashi: {
    type: Boolean,
    default: null,
  },
  menuPointBenefits: {
    type: Boolean,
    default: null,
  },
  isContentLoaded: {
    type: Boolean,
    default: null,
  },
})


const companyCopyright = ref(data.default.companyCopyright)

const isHome = computed(() => {
  return route.path === '/'
})

const isFlyerView  = computed(() => {
  return true
})

const cssVars = computed(() => {
  return {
    '--height': '6.4rem'
  }
})

</script>

<style lang="scss" scoped>
.app-footer {
  box-sizing: border-box;
  position: relative;
  height: var(--height);

  @media screen and (min-width: $tablet-breakpoint) {
    height: auto;
  }

  .app-footer__nav {
    width: 100%;
    text-align: center;
    padding: 1.6rem 0;
    font-size: 1.2rem;
    line-height: calc(13.8 / 12);
    font-family: Arial, Helvetica, sans-serif;

    @media screen and (min-width: $tablet-breakpoint) {
      padding: 1.6rem 0;
      font-size: 1.2rem;
      line-height: calc(13 / 12);
      background: $color-white;
    }
  }

  .app-footer__nav > li:not(:last-child) {
    padding-bottom: 0.4rem;
  }

  .app-footer__nav-link {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    font-family: $font-hiragino;
    color: #333;
    padding: 1.5rem 0;

    &:hover {
      color: #f27346;
    }

    @media screen and (min-width: $tablet-breakpoint) {
      font-size: 16px;
      padding: 15px 0;
    }

    &::before {
      content: '';
      width: 1.6rem;
      height: 1.6rem;
      margin-right: 1rem;
      background-repeat: no-repeat;
      background-image: url('~assets/images/icon-pc.svg');
      background-size: contain;

      @media screen and (min-width: $tablet-breakpoint) {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
    }
  }
  .app-footer__nav-link-home {
    &::before {
      background-image: url('~assets/images/icon-home.svg');
    }
  }
}
</style>
